import React from "react"

import Layout from "../components/layout"
import styles from "./privacyPolicy.module.scss"
import reusedStyles from "./legal.module.scss"
import globalStyles from "../services/globalStyles.module.scss"
import Header from "../components/header"
import Footer from "../components/footer"
import Translate from "../components/translate";
import { graphql } from "gatsby";

class PrivacyPolicyPage extends React.Component {
  render() {
    const { texts: { _ }, privacyText: { text: { privacy } } } = this.props.data;
    const languageCode = this.props.pageContext && this.props.pageContext.lang ? this.props.pageContext.lang : "en";

    return (
      <Layout header={<Header num={1} translations={_} fixed languageCode={languageCode} />} translations={_} languageCode={languageCode}>
        <div className={[globalStyles.contentContainer190, reusedStyles.content].join(' ')}>
          <h1>{privacy.privacy_policy}</h1>
          <p style={{ fontWeight: "bold" }}>
            <Translate template={privacy.welcome_and_thank_you}>
              <a className={[styles.anchor, globalStyles.hyperlink].join(' ')} target="_blank" href="http://www.sidelinesports.com" />
              <a className={[styles.anchor, globalStyles.hyperlink].join(' ')} target="_blank" href="https://app.xpsnetwork.com" />
              <a className={[styles.anchor, globalStyles.hyperlink].join(' ')} target="_blank" href="http://xpsnetwork.com" />
            </Translate>
          </p>
          <p>
            {privacy.privacy_policy_paragraph}
          </p>
          <p>
            {privacy.privacy_policy_paragraph2}
          </p>
          <ol>
            <li>
              {privacy.definitions}
              <div className={reusedStyles.block}>
                <span className={reusedStyles.blockHeader}>
                  "{privacy.user}"
              </span>
                <span className={[reusedStyles.blockText, styles.blockText].join(' ')}>
                  {privacy.user_meaning}
                </span>
              </div>
              <div className={reusedStyles.block}>
                <span className={reusedStyles.blockHeader}>
                  "{privacy.user_data}"
              </span>
                <span className={[reusedStyles.blockText, styles.blockText].join(' ')}>
                  {privacy.user_data_meaning}
                </span>
              </div>
              <div className={reusedStyles.block}>
                <span className={reusedStyles.blockHeader}>
                  “{privacy.personal_data}”
              </span>
                <span className={[reusedStyles.blockText, styles.blockText].join(' ')}>
                  {privacy.personal_data_meaning}
                </span>
              </div>
              <div className={reusedStyles.block}>
                <span className={reusedStyles.blockHeader}>
                  “{privacy.public_area}”
              </span>
                <span className={[reusedStyles.blockText, styles.blockText].join(' ')}>
                  {privacy.public_area_meaning}
                </span>
              </div>
              <div className={reusedStyles.block}>
                <span className={reusedStyles.blockHeader}>
                  “{privacy.restricted_area}”
              </span>
                <span className={[reusedStyles.blockText, styles.blockText].join(' ')}>
                  {privacy.restricted_area_meaning}
                </span>
              </div>
              <div className={reusedStyles.block}>
                <span className={reusedStyles.blockHeader}>
                  “{privacy.user}”
              </span>
                <span className={[reusedStyles.blockText, styles.blockText].join(' ')}>
                  {privacy.user_meaning2}
                </span>
              </div>
              <div className={reusedStyles.block}>
                <span className={reusedStyles.blockHeader}>
                  “{privacy.visitor}”
              </span>
                <span className={[reusedStyles.blockText, styles.blockText].join(' ')}>
                  {privacy.visitor_meaning}
                </span>
              </div>
            </li>
            <li>
              {privacy.info_we_collect}
              <p className={reusedStyles.paymentParagraph}>
                {privacy.info_we_collect_paragraph}
              </p>
              <ol className={reusedStyles.nestedList}>
                <li>
                  {privacy.user_provided_info}
                  <span className={reusedStyles.nestedListItem}>
                    {privacy.user_provided_info_paragraph}
                  </span>
                </li>
                <li>
                  {privacy.info_collected_by_users}
                  <span className={reusedStyles.nestedListItem}>
                    {privacy.info_collected_by_users_paragraph}
                  </span>
                </li>
                <li>
                  {privacy.automatically_collected}
                  <span className={reusedStyles.nestedListItem}>
                    {privacy.automatically_collected_paragraph}
                  </span>
                </li>
                <li>
                  {privacy.integrated_services}
                  <span className={reusedStyles.nestedListItem}>
                    {privacy.integrated_services_paragraph}
                  </span>
                </li>
                <li>
                  {privacy.info_from_other}
                  <span className={reusedStyles.nestedListItem}>
                    {privacy.info_from_other_paragraph}
                  </span>
                </li>
              </ol>
            </li>
            <li>
              {privacy.how_we_use_info}
              <p className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                {privacy.how_we_use_info_paragraph}
              </p>
              <ol className={[reusedStyles.nestedList, styles.nestedList].join(' ')}>
                <li>
                  {privacy.operations}
                  <div className={[reusedStyles.nestedListItem, styles.nestedListItem].join(' ')}>
                    {privacy.operations_paragraph}
                  </div>
                </li>
                <li>
                  {privacy.improvements}
                  <div className={[reusedStyles.nestedListItem, styles.nestedListItem].join(' ')}>
                    {privacy.imporvements_paragraph}
                  </div>
                </li>
                <li>
                  {privacy.communications}
                  <div className={[reusedStyles.nestedListItem, styles.nestedListItem].join(' ')}>
                    {privacy.communications_paragraph}
                  </div>
                </li>
                <li>
                  {privacy.cookies_and_tracking}
                  <div className={[reusedStyles.nestedListItem, styles.nestedListItem].join(' ')}>
                    <Translate template={privacy.cookies_and_tracking_paragraph}><a className={[styles.anchor, globalStyles.hyperlink].join(' ')} href="http://www.allaboutcookies.org" /></Translate>
                  </div>
                </li>
                <li>
                  {privacy.analytics}
                  <div className={[reusedStyles.nestedListItem, styles.nestedListItem].join(' ')}>
                    <Translate template={privacy.analytics_paragraph}><a className={[styles.anchor, globalStyles.hyperlink].join(' ')} href="https://support.google.com/analytics/answer/6004245" /></Translate>
                  </div>
                </li>
              </ol>
              <p className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                {privacy.analytics_paragraph2}
              </p>
            </li>
            <li>
              {privacy.to_whom_we_disclose_info.header}
              <p className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                {privacy.to_whom_we_disclose_info.paragraph}
              </p>
              <ol className={[reusedStyles.nestedList, styles.nestedList].join(' ')}>
                {privacy.to_whom_we_disclose_info.items.map((val, index) => {
                  return <li key={index}>
                    {val.header}
                    {val.paragraph.map((paragraphVal, index) => {
                      return <div key={index} className={[reusedStyles.nestedListItem, styles.nestedListItem].join(' ')}>
                        {paragraphVal}
                      </div>
                    })}

                  </li>
                })}
              </ol>
            </li>
            <li>
              {privacy.your_choices.header}
              <ol className={[reusedStyles.nestedList, styles.nestedList].join(' ')}>
                {privacy.your_choices.items.map((val, index) => {
                  return <li key={index}>
                    {val.header}
                    {val.paragraph.map((paragraphVal, index) => {
                      return <div key={index} className={[reusedStyles.nestedListItem, styles.nestedListItem].join(' ')}>
                        <Translate template={paragraphVal}><a className={[styles.anchor, globalStyles.hyperlink].join(' ')} href="https://tools.google.com/dlpage/gaoptout" /></Translate>
                      </div>
                    })}
                  </li>
                })}
              </ol>
            </li>
            <li>
              {privacy.third_party_services.header}
              <p className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                {privacy.third_party_services.paragraph}
              </p>
            </li>
            <li>
              {privacy.your_california_privacy_rights.header}
              <p className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                {privacy.your_california_privacy_rights.paragraph}
              </p>
            </li>
            <li>
              {privacy.interest_based_advertising.header}
              {privacy.interest_based_advertising.paragraph.map((val, index) => {
                return <p key={index} className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                  <Translate template={val}><a className={[styles.anchor, globalStyles.hyperlink].join(' ')} href="http://www.aboutads.info/consumers" /><a className={[styles.anchor, globalStyles.hyperlink].join(' ')} href="http://www.networkadvertising.org" /></Translate>
                </p>
              })}
            </li>
            <li>
              {privacy.do_not_track_policy.header}
              {privacy.do_not_track_policy.paragraph.map((val, index) => {
                return <p key={index} className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                  <Translate template={val}><a className={[styles.anchor, globalStyles.hyperlink].join(' ')} href="http://www.aboutads.info/consumers" /><a className={[styles.anchor, globalStyles.hyperlink].join(' ')} href="http://www.networkadvertising.org" /></Translate>
                </p>
              })}
            </li>
            <li>
              {privacy.third_party_cookies.header}
              {privacy.third_party_cookies.paragraph.map((val, index) => {
                return <p key={index} className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                  {val}
                </p>
              })}
              <ol className={[reusedStyles.nestedList, styles.nestedList].join(' ')}>
                {privacy.third_party_cookies.items.map((val, index) => {
                  return <li key={index}>
                    {val.header}
                    {val.items && <ol>
                      {val.items.map((val, index) => {
                        return <li key={index} className={reusedStyles.nestedListItem}>{val}</li>
                      })}
                    </ol>}
                    {val.table && <table className={styles.cookieTable}>
                      <tbody>
                        <tr>
                          <th>{val.table.service_provider_header}</th>
                          <th>{val.table.cookie_name_header}</th>
                          <th>{val.table.cookie_type_header}</th>
                          <th>{val.table.expiration_header}</th>
                          <th>{val.table.content_header}</th>
                        </tr>
                        {val.table.rows.map((val, index) => {
                          return <tr key={index}>
                            {val.items.length > 1 && val.items.map((val, index) => {
                              return <td key={index}>{val}</td>
                            })}
                            {val.items.length === 1 && <td colSpan="5" style={{ textAlign: "center" }}>{val.items[0]}</td>}
                          </tr>
                        })}
                      </tbody>
                    </table>}
                  </li>
                })}
              </ol>
            </li>
            <li>
              {privacy.minors_and_children_privacy.header}
              {privacy.minors_and_children_privacy.paragraph.map((val, index) => {
                return <p key={index} className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                  {val}
                </p>
              })}
            </li>
            <li>
              {privacy.data_security.header}
              {privacy.data_security.paragraph.map((val, index) => {
                return <p key={index} className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                  {val}
                </p>
              })}
            </li>
            <li>
              {privacy.data_retention.header}
              {privacy.data_retention.paragraph.map((val, index) => {
                return <div key={index}><p className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                  {val.paragraph}
                </p>
                  <ol className={[reusedStyles.nestedList, styles.nestedList].join(' ')}>
                    {val.points.map((val, index) => {
                      return <li key={index} style={{ fontWeight: "normal" }}>
                        {val}
                      </li>
                    })}
                  </ol>
                </div>
              })}
            </li>
            <li>
              {privacy.settings.header}
              <p className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                {privacy.settings.paragraph}
              </p>
            </li>
            <li>
              {privacy.data_transfer.header}
              {privacy.data_transfer.paragraph.map((val, index) => {
                return <p key={index} className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                  {val}
                </p>
              })}
            </li>
            <li>
              {privacy.data_controller_and_data_processor.header}
              {privacy.data_controller_and_data_processor.paragraph.map((val, index) => {
                return <p key={index} className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                  {val}
                </p>
              })}
            </li>
            <li>
              {privacy.changes_and_updates_to_this_policy.header}
              <p className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                {privacy.changes_and_updates_to_this_policy.paragraph}
              </p>
            </li>
            <li>
              {privacy.how_to_contact_us.header}
              <p className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
                {privacy.how_to_contact_us.paragraph}
              </p>
            </li>
          </ol>
          <p className={[reusedStyles.paymentParagraph, styles.paragraph].join(' ')}>
            {privacy.last_update}
          </p>
            </div>
        <Header num={2} translations={_} className={globalStyles.hideOnMobile} languageCode={languageCode} />
        <Footer translations={_} languageCode={languageCode} />
      </Layout>
    )
  }
}
export default PrivacyPolicyPage

export const query = graphql`
  query Privacy($langFile: String) {
    site {
      siteMetadata {
        ip_stack_key
      }
    }
    texts: file(relativePath: {eq: $langFile}) {
      _: childTextsYaml {
        ...HeaderTranslations
        ...FooterTranslations
        and
        chat {
          full_name
          email
          message
          send_message
          success_message
          success_info
          success
          message_placeholder
        }
      }
    }
    privacyText: file(name: { eq: "privacy" }) {
      text: childLegalContentYaml {
        privacy{
          privacy_policy
          welcome_and_thank_you
          privacy_policy_paragraph
          privacy_policy_paragraph2
          definitions
          user
          user_meaning
          user_data
          user_data_meaning
          personal_data
          personal_data_meaning
          public_area
          public_area_meaning
          restricted_area
          restricted_area_meaning
          user_meaning2
          visitor
          visitor_meaning
          info_we_collect
          info_we_collect_paragraph
          user_provided_info
          user_provided_info_paragraph
          info_collected_by_users
          info_collected_by_users_paragraph
          automatically_collected
          automatically_collected_paragraph
          integrated_services
          integrated_services_paragraph
          info_from_other
          info_from_other_paragraph
          how_we_use_info
          how_we_use_info_paragraph
          operations
          operations_paragraph
          improvements
          imporvements_paragraph
          communications
          communications_paragraph
          cookies_and_tracking
          cookies_and_tracking_paragraph
          analytics
          analytics_paragraph
          analytics_paragraph2
          to_whom_we_disclose_info{
            header
            paragraph
            items{
              header
              paragraph
            }
          }
          your_choices{
            header
            items{
              header
              paragraph
            }
          }
          third_party_services{
            header
            paragraph
          }
          your_california_privacy_rights{
            header
            paragraph
          }
          interest_based_advertising{
            header
            paragraph
          }
          do_not_track_policy{
            header
            paragraph
          }
          third_party_cookies{
            header
            paragraph
            items{
              header
              items
              table{
                service_provider_header
                cookie_name_header
                cookie_type_header
                expiration_header
                content_header
                rows{
                  items
                }
              }
            }
          }
          minors_and_children_privacy{
            header
            paragraph
          }
          data_security{
            header
            paragraph
          }
          data_retention{
            header
            paragraph{
              paragraph
              points
            }
          }
          settings{
            header
            paragraph
          }
          data_transfer{
            header
            paragraph
          }
          data_controller_and_data_processor{
            header
            paragraph
          }
          changes_and_updates_to_this_policy{
            header
            paragraph
          }
          how_to_contact_us{
            header
            paragraph
          }
          last_update
        }
      }
    }
  }`
